import { IDjangoApi1License } from '../../tn.common';

export function hasFurtherUpgrades(
    licenses: IDjangoApi1License[],
    key: string
): IDjangoApi1License[] {
    return licenses.filter(
        (license) =>
            license.fontRights[key] &&
            (license.fontRights[key].qty !== -1 ||
                license.fontRights[key].years !== -1)
    );
}
